import { openOnboarding } from './openOnboarding'

import type { ShopifyOnboardingDestinationResolver } from '@/features/integrations'

/**
 * Module 29's decision for a Shopify return: a FIRST store connection reopens onboarding at the
 * Connections step (ORP-20019 / ledger A19 — deliberately not v3's step 2). There is no destination
 * to navigate to any more; the takeover opens over wherever the return landed.
 */
export const resolveShopifyOnboardingDestination: ShopifyOnboardingDestinationResolver = (
  result,
) => {
  if (!result.existingIntegration) openOnboarding('connections')
  // No redirect: the return stays where it landed, under the takeover.
  return null
}
